import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { TableHeadCell } from '../table-cells/TableCells';
import DomainControllerTableRow from './DomainControllerTableRow';

import {
  useGetAuthenticationQuery,
  useGetDomainControllersQuery,
} from '../../services/ADapi';

const DomainControllerTable = () => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const { data: controllers, isLoading } =
    useGetDomainControllersQuery(user_id);

  if (isLoading) return <h2>Loading...</h2>;

  return (
    <TableContainer sx={{ pt: 3 }}>
      <Table sx={{ minWidth: '650px' }}>
        <TableHead>
          <TableRow>
            <TableHeadCell sx={{ width: '300px' }}>Name</TableHeadCell>
            <TableHeadCell align="left" sx={{ width: '455px' }}>
              IP addresses
            </TableHeadCell>
            <TableHeadCell align="left">Type</TableHeadCell>
            <TableHeadCell></TableHeadCell>
            <TableHeadCell></TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {controllers?.map(({ id, name, ips, is_pdc }) => (
            <DomainControllerTableRow
              key={`${id}-controller`}
              id={id}
              name={name}
              numberOfIPs={ips.length}
              isPDC={is_pdc}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DomainControllerTable;
